import React from 'react';
import { Container, CardContent } from '@material-ui/core';
import { CardWrapper, CardTitle } from './components/ResetPassword.style';
import { t } from '../../../i18n';
import ResetPasswordForm from './components/ResetPassword.form';
import Routes from '../../Navigator/Navigator.route';
import { useHistory } from 'react-router-dom';
import SuccessScreen from 'src/components/SuccessScreen/SuccessScreen';

interface IProps {
  cookies: any;
}

const ResetPasswordView: React.FC<IProps> = ({ cookies }) => {
  const history = useHistory();
  const [
    isResetPasswordSuccessful,
    setResetPasswordSuccessful
  ] = React.useState<boolean>(false);

  const handleBackToDashboard = () => {
    history.push(Routes.SignIn);
  };

  return (
    <Container>
      {isResetPasswordSuccessful ? (
        <SuccessScreen
          isShowSuccessIcon={true}
          isShowReturnIcon={false}
          titleMessage={t('resetPassword.successful.title')}
          descriptionMessage={t('setPassword.successful.description')}
          buttonBackMessage={t('resetPassword.successful.buttonBack')}
          handleGoBack={handleBackToDashboard}
        />
      ) : (
        <CardWrapper>
          <CardContent>
            <CardContent>
              <CardTitle>{t('resetPassword.title')}</CardTitle>
              <ResetPasswordForm
                cookies={cookies}
                setResetPasswordSuccessful={setResetPasswordSuccessful}
              />
            </CardContent>
          </CardContent>
        </CardWrapper>
      )}
    </Container>
  );
};

export default ResetPasswordView;
